export const routes = {
  LOGIN: '/login',
  VERIFY_OTP: '/verify-otp',
  UAE_PASS_CALLBACK: '/auth/uae-pass/callback',
  DASHBOARD: '/dashboard',
  PROPERTIES: '/properties',
  PROPERTY_DETAIL: '/properties/:id',
  ORDER_SUCCESS: '/properties/:id/order-success',
  ORDER_DETAIL: '/properties/:id/orders/:orderId',
  MARKETPLACE: '/marketplace',
  PORTFOLIO: '/portfolio',
  MY_ORDERS: '/portfolio/orders',
  INVESTMENT_DETAIL: '/portfolio/investments/:id',
  ERROR: '/error',
  NOTFOUND: '/not-found',
  LANDING: '/',
  SIGNUP: '/signup',
  UAE_PASS_SIGNUP: '/signup/uae-pass',
  ONBOARDING_WIZARD: '/onboarding',
  RISK_PROFILE: '/risk-profile',
  PROFILE: '/profile',
  DOCUMENT_PREVIEW: '/profile/documents/:title',
  BANK_ACCOUNTS: '/bank-accounts',
  ADD_BANK_ACCOUNT: '/bank-accounts/add',
  BANK_ACCOUNT_DETAIL: '/bank-accounts/:id',
  SETTINGS: '/settings',
  HELP: '/help',
  NOTIFICATIONS: '/notifications',
  WALLET: '/wallet',
  WALLET_DEPOSIT_SUCCESS: '/wallet/deposit/success',
  INVESTMENT_CALCULATOR: '/investment-calculator',
  MARKET_PULSE: '/dashboard/articles',
  MARKET_PULSE_ARTICLE: '/dashboard/articles/:id',
  EXPLORE_VIDEOS: '/dashboard/videos',
} as const
